@if (!loading) {
  <!-- details dialog -->
  <p-dialog [header]="i18n?.i18nLng()['DETAILS']"
            [modal]="true"
            [(visible)]="showOrganisationDetailsDialog"
            [style]="{width: '57rem'}"
            [closable]="true"
            [resizable]="false"
            [draggable]="false"
            (visibleChange)="$event === false ? closeDetailsDialog() : null">
    <customer-data-details-dialog [organisationData]="selectedRowData"
                                  [organisationPaymentTypes]="organisationPaymentTypes">
    </customer-data-details-dialog>
    <ng-template #footer class="pt-3">
      <p-button [label]="i18n.i18nLng()['CLOSE']" (onClick)="closeDetailsDialog()"/>
    </ng-template>
  </p-dialog>

  @if (showCustomerDataDialog) {
    <!-- customer data dialog -->
    <p-dialog [header]="i18n?.i18nLng()['CUSTOMERDATA']"
              [modal]="true"
              [(visible)]="showCustomerDataDialog"
              [style]="{width: '57rem'}"
              [closable]="true"
              [resizable]="false"
              [draggable]="false"
              (visibleChange)="$event === false ? closeCustomerDataDialog() : null">
      <customer-data-edit-dialog [organisationData]="selectedRowData"
                                 [referralPartnerList]="referralPartnerList"
                                 [organisationRzList]="dataCenterList"
                                 [organisationDataInvalidFlags]="organisationDataInvalidFlags"
                                 (dataValidated)="onDataValidated($event)">
      </customer-data-edit-dialog>
      <ng-template #footer class="pt-3">
        <p-button [label]="i18n.i18nLng()['CANCEL']" severity="secondary" (click)="closeCustomerDataDialog()"/>
        <p-button [label]="i18n.i18nLng()['SAVE']" (onClick)="saveOrganisationData()" [disabled]="dataValid=== false"/>
      </ng-template>
    </p-dialog>
  }

  <!-- status change dialog -->
  <p-dialog [header]="i18n?.i18nLng()['STATUSCHANGE']"
            [modal]="true"
            [(visible)]="showStatusChangeDialog"
            [style]="{width: '25rem'}"
            [closable]="true"
            [resizable]="false"
            [draggable]="false">
    <div class="flex flex-column align-items-start gap-3 align-self-stretch pb-1 pt-1">
      <fieldset class="sps-fieldset form-data-container">
        <div class="flex gap-2">
          <label for="current-status">
            {{ i18n.i18nLng()['CURRENTSTATUS'] }}:
          </label>
          <p-tag id="current-status"
                 [value]="selectedRowData?.customerStatus | customerStatusTag : 'VALUE'"
                 [severity]="selectedRowData?.customerStatus | customerStatusTag : 'SEVERITY'"
                 [icon]="selectedRowData?.customerStatus | customerStatusTag : 'ICON'"/>
        </div>
        <div class="flex flex-column gap-2 w-full">
          <label for="new-status">
            {{ i18n.i18nLng()['NEWSTATUS'] }}
          </label>
          <p-select [(ngModel)]="newStatus"
                    inputId="new-status"
                    [options]="newStatusList"
                    [showClear]="false"
                    [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                    size="large"
                    appendTo="body"
                    [attr.aria-label]="i18n.i18nLng()['NEWSTATUS']"/>
        </div>
      </fieldset>
    </div>
    <ng-template #footer>
      <p-button [label]="i18n.i18nLng()['CANCEL']" severity="secondary" (click)="showStatusChangeDialog = false"/>
      <p-button [label]="i18n.i18nLng()['SAVE']" (onClick)="saveNewStatus()" [disabled]="newStatus === null"/>
    </ng-template>
  </p-dialog>

  <div class="grid">
    <div class="col-12">
      <p-card class="h-full">
        <ng-template pTemplate="title">
          <div [ngClass]="layoutService.isMobile() ? 'flex flex-column gap-2 align-items-start' : 'flex flex-1 gap-2 align-self-stretch align-items-center'">
            <div class="flex flex-1 align-items-center gap-3">
              <div style="word-break: keep-all">{{ totalRecords?.toString() + ' ' + i18n?.i18nLng()['ORGANISATIONS'] }}</div>
            </div>
            <p-button [label]="i18n.i18nLng()['CLEAR']"
                      [ariaLabel]="i18n?.i18nLng()['CLEARALLFILTERS']"
                      [pTooltip]="i18n?.i18nLng()['CLEARALLFILTERS']"
                      tooltipPosition="top"
                      [outlined]="true"
                      icon="pi pi-filter-slash"
                      (click)="clearTableFilters()"/>
            <p-split-button icon="pi pi-user-edit"
                            [label]="i18n?.i18nLng()['DETAILS']"
                            [model]="adminMenuItems"
                            [disabled]="!adminMenuActive"
                            (onClick)="showDetailsDialog()"
                            (onDropdownClick)="checkOnboardingMode()"
                            [expandAriaLabel]="i18n.i18nLng()['SPLITBUTTONEXPANDINFO']"
                            [pTooltip]="i18n.i18nLng()['SPLITBUTTONINFO']"
                            tooltipPosition="top"/>
          </div>
        </ng-template>
        @if (!tableControlService.refreshTableConfig()) {
          <sps-table [tableConfig]="tableConfig()"
                     [rows]="rows"
                     [tableListProvider]="tableListProvider"
                     [parentDataProvider]="getOrganisationPageData"
                     [tableControlService]="tableControlService"
                     [scrollHeightOffset]="scrollHeightOffset"
                     [minScrollHeight]="minScrollHeight"
                     [freezeColumns]="true"
                     [showTogglerIcon]="false"
                     (dataFetched)="onDataFetched($event)"
                     (selectionChanged)="onSelectionChanged($event)"
                     (rowsCountChanged)="rowsCountChanged($event)"
                     (stateRestored)="onStateRestored($event)">
          </sps-table>
        }
      </p-card>
    </div>
  </div>
}
